const faqData = [
  {
    id: 'tickets',
    label: 'Tickets',
    accent: 'purple',
    items: [
      {
        question: 'Can I upgrade my standard pass to VIP?',
        answer:
          'Yes. VIP upgrades may be available during checkout or later, depending on remaining availability. VIP access includes faster entry and selected premium zones.',
      },
      {
        question: 'How do I access my digital tickets?',
        answer:
          'After booking, your ticket confirmation is sent by email. In this demo flow, the reservation is saved instantly and payment confirmation is represented as a follow-up step.',
      },
      {
        question: 'What is the refund policy?',
        answer:
          'Eligible tickets can be cancelled up to 14 days before the event. Refund rules may vary depending on the selected pass type.',
      },
    ],
  },
  {
    id: 'venue',
    label: 'Venue',
    accent: 'cyan',
    items: [
      {
        question: 'Is there on-site parking available?',
        answer:
          'Limited parking is available near the venue. We recommend using public transport or ride-sharing during peak festival hours.',
      },
      {
        question: 'What time do gates open?',
        answer:
          'Gates usually open in the early afternoon. Exact opening hours may vary by festival day and will be included in your ticket details.',
      },
      {
        question: 'Can I bring food and drinks?',
        answer:
          'Outside food and drinks are usually restricted. Food zones, bars, and water refill points are available inside the festival area.',
      },
    ],
  },
  {
    id: 'safety',
    label: 'Safety',
    accent: 'pink',
    items: [
      {
        question: 'Are there water refill stations?',
        answer:
          'Yes. Water refill stations are placed across the venue and marked on the festival map.',
      },
      {
        question: 'What should I do if I lose my friends?',
        answer:
          'Use the designated meeting points near the main entrance and information zones. Festival staff can also help you reconnect safely.',
      },
      {
        question: 'Is medical support available?',
        answer:
          'Yes. Medical teams are available on-site throughout the event and can be reached through festival staff or marked assistance points.',
      },
    ],
  },
  {
    id: 'lineup',
    label: 'Lineup',
    accent: 'purple',
    items: [
      {
        question: 'Can the lineup change?',
        answer:
          'Yes. Artist schedules may change due to production or travel reasons. Any important updates will be reflected on the lineup page.',
      },
      {
        question: 'Can I search artists by genre?',
        answer:
          'The lineup can be searched by performer name and filtered by day. Genre-based filtering can be added as a future improvement.',
      },
    ],
  },
];

export default faqData;
